import { Alert, AlertTitle } from "@mui/material";
import useLocales from "src/hooks/useLocales";

export default function SecretInfoAlert() {
	const { translate } = useLocales();

	return (
		<Alert severity='warning'>
			<AlertTitle>{translate("app_secrets.copy_secret_warning")}</AlertTitle>
			{translate("app_secrets.copy_secret_warning_des")}
		</Alert>
	);
}
